export default __webpack_public_path__ + "static/media/icon_event_subscribe.b8521b35.svg";